import { Box, P, Stack, Text, Button, L8 } from "@adfenix/alexandria";
import { ErrorContent } from "api/http";
import { useCognito } from "hooks";
import { useState } from "react";
import { useProSidebar } from "react-pro-sidebar";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Visible } from "react-grid-system";
import styled from "styled-components";
import { MasqueradeModal } from "./MasqueradeModal";
import UiArrowToLeft from "@iconscout/react-unicons/icons/uil-arrow-circle-left";
import useUserInfo from "hooks/useUserInfo";
import { stopMasquerading } from "api/services";
import { Profile } from "./Profile";

const StyledUiArrowToLeft = styled(UiArrowToLeft)<{
  dark: boolean;
}>`
  color: ${({ theme, dark }) => (dark ? "white" : L8(theme.colors.black))};
  width: 40px;
  height: 40px;
`;

const StyledText = styled(P)`
  color: rgb(161, 170, 199);
`;

export const SidebarFooter = () => {
  const { forceRefreshToken } = useCognito();
  const { masqueradeUserEmail, masqueradeUserId, roleName } = useUserInfo();

  const [isModalOpen, setModal] = useState(false);
  const { toggleSidebar, toggled } = useProSidebar();
  const { mutateAsync: stopUserMasquerading, isLoading: stopingMasquerading } =
    useMutation(stopMasquerading, {
      onSuccess: async () => {
        setModal(true);
        await forceRefreshToken();
      },
      onError(error: ErrorContent) {
        toast.error(error.content);
      }
    });
  return (
    <>
      <Box style={{ marginTop: "auto" }}>
        <div>
          {masqueradeUserId && (
            <Stack spacing={"xs2"}>
              <Box>
                <Text bold color={"danger"}>
                  Masquerading as
                </Text>
              </Box>
              <Box>
                <StyledText bold>{masqueradeUserEmail}</StyledText>
              </Box>
              <Box>
                <StyledText>{roleName}</StyledText>
              </Box>
              <Button
                logLabel="stop-masquerading-button"
                size="small"
                isLoading={stopingMasquerading}
                onClick={() => stopUserMasquerading()}
              >
                Stop Masquerading
              </Button>
            </Stack>
          )}
        </div>
        <Visible xs>
          {toggled ? (
            <Box pX="xs">
              <Button
                logLabel="close-sidebar-button"
                variant="secondaryText"
                onClick={() => toggleSidebar(false)}
              >
                <StyledUiArrowToLeft dark />
              </Button>
            </Box>
          ) : (
            <></>
          )}
        </Visible>

        <Profile />
      </Box>
      <MasqueradeModal
        closeModal={() => setModal(false)}
        isModalOpen={isModalOpen}
        masqueradeUserEmail={masqueradeUserEmail}
      />
    </>
  );
};
